/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { ActionsObservable, StateObservable } from 'redux-observable';
import { isOfType } from 'typesafe-actions';
import { filter, map, mergeMap } from 'rxjs/operators';
import { catchError } from 'rxjs/internal/operators/catchError';
import { from, of } from 'rxjs';

import {
  getProjectListSuccess,
  getProjectListFailure,
  GetProjectListAction,
  GetProjectListActionTypes,
} from '../actions/GetProjectList';
import getProjectListService from '../services/GetProjectList';
import { IErrorActionData } from '../../../models/Error';
import RootState from '../../../config/store/RootState';
import RootAction from '../../../config/store/RootAction';

const GetProjectListEpic = (action$: ActionsObservable<RootAction>, state$: StateObservable<RootState>) => action$.pipe(
  filter(isOfType(GetProjectListActionTypes.GET_PROJECT_LIST)),
  mergeMap((action: GetProjectListAction) => from(
    getProjectListService(
      action.payload.page,
    ),
  ).pipe(
    map((response) => getProjectListSuccess({
      data: response.data.getProjectList.data || [],
      pageInfo: response.data.getProjectList.pageInfo,
    })),
    catchError((error: IErrorActionData) => of(
      getProjectListFailure({
        errorCode: error.errorCode || 500,
        errorMessage: error.errorMessage,
        callBack: error.callBack,
      }),
    )),
  )),
);

export default GetProjectListEpic;
